import * as React from "react";
const SvgCamera = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M2 5q10-.018 20 0v16q-10 .019-20 0zm2 2v12h16V7zm10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10M5 2h5v2H5z" })));
export default SvgCamera;
//# sourceMappingURL=Camera.js.map